// Author YuJiaBei
// Date 2021-06-21 17:50:20

class EmOpcUaNodeInfoEouni {
constructor({
        id = null,
        nodeId = '',
        eouniNodeidNamespaceIndex = '',
        eouniNodeidIdentifier = '',
        eouniIsForward = '',
        eouniReferenceNamespaceIndex = '',
        eouniReferenceIdentifier = '',
        eouniBrowsenameName = '',
        eouniDisplaynameText = '',
        eouniNodeclassValue = '',
        eouniNodeclassName = '',
        eouniTypeDefinationNamespaceIndex = '',
        eouniTypeDefinationIdentifier = '',
        remark = ''}
= {}) {
    this.id = id;
    this.nodeId = nodeId;
    this.eouniNodeidNamespaceIndex = eouniNodeidNamespaceIndex;
    this.eouniNodeidIdentifier = eouniNodeidIdentifier;
    this.eouniIsForward = eouniIsForward;
    this.eouniReferenceNamespaceIndex = eouniReferenceNamespaceIndex;
    this.eouniReferenceIdentifier = eouniReferenceIdentifier;
    this.eouniBrowsenameName = eouniBrowsenameName;
    this.eouniDisplaynameText = eouniDisplaynameText;
    this.eouniNodeclassValue = eouniNodeclassValue;
    this.eouniNodeclassName = eouniNodeclassName;
    this.eouniTypeDefinationNamespaceIndex = eouniTypeDefinationNamespaceIndex;
    this.eouniTypeDefinationIdentifier = eouniTypeDefinationIdentifier;
    this.remark = remark;
}
}

function newEntity() {
return new EmOpcUaNodeInfoEouni();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'nodeId',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.grid.nodeId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eouniNodeidNamespaceIndex',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.grid.eouniNodeidNamespaceIndex',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eouniNodeidIdentifier',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.grid.eouniNodeidIdentifier',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eouniIsForward',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.grid.eouniIsForward',
        sortable: true,
        form: {
        type: 'boolean'
        }
        },
        {
        key: 'eouniReferenceNamespaceIndex',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.grid.eouniReferenceNamespaceIndex',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eouniReferenceIdentifier',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.grid.eouniReferenceIdentifier',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eouniBrowsenameName',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.grid.eouniBrowsenameName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eouniDisplaynameText',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.grid.eouniDisplaynameText',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eouniNodeclassValue',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.grid.eouniNodeclassValue',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eouniNodeclassName',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.grid.eouniNodeclassName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eouniTypeDefinationNamespaceIndex',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.grid.eouniTypeDefinationNamespaceIndex',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eouniTypeDefinationIdentifier',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.grid.eouniTypeDefinationIdentifier',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    nodeIdFilter : "",
    eouniNodeidNamespaceIndexFilter : "",
    eouniNodeidIdentifierFilter : "",
    eouniIsForwardFilter : "",
    eouniReferenceNamespaceIndexFilter : "",
    eouniReferenceIdentifierFilter : "",
    eouniBrowsenameNameFilter : "",
    eouniDisplaynameTextFilter : "",
    eouniNodeclassValueFilter : "",
    eouniNodeclassNameFilter : "",
    eouniTypeDefinationNamespaceIndexFilter : "",
    eouniTypeDefinationIdentifierFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nodeIdFilter',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.filter.nodeId',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eouniNodeidNamespaceIndexFilter',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.filter.eouniNodeidNamespaceIndex',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eouniNodeidIdentifierFilter',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.filter.eouniNodeidIdentifier',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eouniIsForwardFilter',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.filter.eouniIsForward',
        disabled: false,
        form: {
        type: 'boolean'
                }
        },
        {
        key: 'eouniReferenceNamespaceIndexFilter',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.filter.eouniReferenceNamespaceIndex',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eouniReferenceIdentifierFilter',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.filter.eouniReferenceIdentifier',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eouniBrowsenameNameFilter',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.filter.eouniBrowsenameName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eouniDisplaynameTextFilter',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.filter.eouniDisplaynameText',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eouniNodeclassValueFilter',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.filter.eouniNodeclassValue',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eouniNodeclassNameFilter',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.filter.eouniNodeclassName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eouniTypeDefinationNamespaceIndexFilter',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.filter.eouniTypeDefinationNamespaceIndex',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eouniTypeDefinationIdentifierFilter',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.filter.eouniTypeDefinationIdentifier',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'nodeId',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.entity.nodeId',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eouniNodeidNamespaceIndex',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.entity.eouniNodeidNamespaceIndex',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eouniNodeidIdentifier',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.entity.eouniNodeidIdentifier',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eouniIsForward',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.entity.eouniIsForward',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean'
                }
        },
        {
        key: 'eouniReferenceNamespaceIndex',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.entity.eouniReferenceNamespaceIndex',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eouniReferenceIdentifier',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.entity.eouniReferenceIdentifier',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eouniBrowsenameName',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.entity.eouniBrowsenameName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eouniDisplaynameText',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.entity.eouniDisplaynameText',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eouniNodeclassValue',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.entity.eouniNodeclassValue',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eouniNodeclassName',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.entity.eouniNodeclassName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eouniTypeDefinationNamespaceIndex',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.entity.eouniTypeDefinationNamespaceIndex',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eouniTypeDefinationIdentifier',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.entity.eouniTypeDefinationIdentifier',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.em.base.opcClient.emOpcUaNodeInfoEouni.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmOpcUaNodeInfoEouni, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
